import { CommonModule, CurrencyPipe, NgOptimizedImage } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AnalyticsModule } from 'src/app/core/analytics/analytics.module';
import { LocaleModule } from 'src/app/core/locale/locale.module';
import { DashboardBookingsComponent } from 'src/app/pages/profile-overview/components/dashboard/components/bookings/dashboard-bookings.component';
import { DashboardHeaderComponent } from 'src/app/pages/profile-overview/components/dashboard/components/header/dashboard-header.component';
import { DashboardMembershipsComponent } from 'src/app/pages/profile-overview/components/dashboard/components/memberships/dashboard-memberships.component';
import { DashboardNoOrdersComponent } from 'src/app/pages/profile-overview/components/dashboard/components/no-orders/dashboard-no-orders.component';
import { DashboardNoPaymentsComponent } from 'src/app/pages/profile-overview/components/dashboard/components/no-payments/dashboard-no-payments.component';
import { DashboardRecentOrdersComponent } from 'src/app/pages/profile-overview/components/dashboard/components/recent-orders/dashboard-recent-orders.component';
import { DashboardComponent } from 'src/app/pages/profile-overview/components/dashboard/dashboard.component';
import { ProfileOverviewRoutingModule } from 'src/app/pages/profile-overview/profile-overview-routing.module';

@NgModule({
	declarations: [
		DashboardComponent,
		DashboardHeaderComponent,
		DashboardRecentOrdersComponent,
		DashboardMembershipsComponent,
		DashboardBookingsComponent,
		DashboardNoOrdersComponent,
		DashboardNoPaymentsComponent,
	],
	imports: [CommonModule, LocaleModule, ProfileOverviewRoutingModule, AnalyticsModule, NgOptimizedImage],
	providers: [CurrencyPipe],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProfileOverviewModule {}
